import { AxiosError } from "axios";
import { getApi, postApi } from "../CreateApi";
import { ExcelParents, ResponseGetRelationFamily } from "./interfaceFamily";

export const postRelationFamilyMany = async (body: { data: ExcelParents[] }): Promise<any> => {
    try {
        const data = await postApi('/relationship/create-many', body);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}


export const getRelationFamily = async (): Promise<ResponseGetRelationFamily[]> => {
    try {
        const data = await getApi(`/relationship`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetRelationFamily[];
    }
}


export const getRelationFamilyClassRooms = async (id: number): Promise<ResponseGetRelationFamily[]> => {
    try {
        const data = await getApi(`/relationship/activity-classroom/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as ResponseGetRelationFamily[];
    }
}

export const getAllFamilies = async (): Promise<any> => {
    try {
        const data = await getApi(`/family`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

export const getAllFamiliesId = async (id: string): Promise<any> => {
    try {
        const data = await getApi(`/family/${id}`);
        return data
    } catch (error) {
        const axiosError = error as AxiosError;
        return axiosError?.response?.data as any;
    }
}

